export default __webpack_public_path__ + "static/media/phone.e0ccc03f.svg";